export const RESERVATION_STATUS_LABELS = {
  approved: 'Approved',
  pending: 'Pending',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  under_review: 'Under Review',
  partially_approved: 'Partially Approved',
};

export const RESERVATION_STATUS_VARIANTS = {
  approved: 'approved',
  pending: 'pending',
  rejected: 'rejected',
  cancelled: 'cancelled',
  under_review: 'under-review',
  partially_approved: 'partially-approved',
};

export const getReservationStatusLabel = (status) =>
  RESERVATION_STATUS_LABELS[status] || 'Unknown';

export const getReservationStatusVariant = (status) =>
  RESERVATION_STATUS_VARIANTS[status] || 'cancelled';
